import React, { useState } from 'react';

import { CustomizableButton } from '~components/common/Button';
import ExternalLinkIcon from '~components/common/ExternalLinkIcon';

import { miniToolProps } from '../propTypes';

export default function BallotTracker({ stateInfos }) {
  const [selectedState, setSelectedState] = useState('');

  // reprocess stateInfos into a simpler map to deal with
  const stateData = {};
  stateInfos.forEach((state) => {
    const stateName = state.fieldValue;
    const absenteeForm = state.nodes.find(
      (node) => node.field_type === 'pdf_absentee_form'
    );
    const emergencyForm = state.nodes.find(
      (node) => node.field_type === 'pdf_emergency_ballot_application'
    );
    const registerForm = state.nodes.find(
      (node) => node.field_type === 'pdf_register_form'
    );
    stateData[stateName] = {
      register: registerForm?.text,
      absentee: absenteeForm?.text,
      emergency: emergencyForm?.text,
    };
  });

  const regStateURL = selectedState && stateData[selectedState].register;
  const absStateURL = selectedState && stateData[selectedState].absentee;
  const emergStateURL = selectedState && stateData[selectedState].emergency;

  const handleChange = (evt) => {
    setSelectedState(evt.target.value);
  };

  const handleClickReg = (evt) => {
    if (!regStateURL) {
      evt.preventDefault();
      evt.stopPropagation();
    }
  };

  const handleClickAbs = (evt) => {
    if (!absStateURL) {
      evt.preventDefault();
      evt.stopPropagation();
    }
  };

  const handleClickEmerg = (evt) => {
    if (!emergStateURL) {
      evt.preventDefault();
      evt.stopPropagation();
    }
  };
  return (
    <div className='mb-14'>
      <p>
        State paper applications for voter registration, absentee, and emergency
        ballots.
      </p>
      <div className='flex max-w-3xl flex-col gap-5 md:flex-row'>
        <div className='flex-1'>
          <select
            name='state'
            id='state'
            onChange={handleChange}
            value={selectedState}
            className='select select-bordered w-full border-base-content bg-base-200 text-base focus:border-base-content'
          >
            <option value='' disabled defaultValue>
              Select a state
            </option>
            {Object.keys(stateData).map((stateName) => (
              <option key={stateName} value={stateName}>
                {stateName}
              </option>
            ))}
          </select>
        </div>
        <div className='w-full md:w-44'>
          <CustomizableButton
            href={regStateURL || '#'}
            onClick={handleClickReg}
            disabled={!regStateURL}
            target='_blank'
            rel='noopener'
            elementType='a'
            supplementalStyling='h-12 min-h-0'
          >
            <span>
              Registration
              <ExternalLinkIcon />
            </span>
          </CustomizableButton>
        </div>
        <div className='w-full md:w-44'>
          <CustomizableButton
            href={absStateURL || '#'}
            onClick={handleClickAbs}
            disabled={!absStateURL}
            target='_blank'
            rel='noopener'
            elementType='a'
            supplementalStyling='h-12 min-h-0'
          >
            <span>
              Absentee
              <ExternalLinkIcon />
            </span>
          </CustomizableButton>
        </div>
        <div className='w-full md:w-44'>
          <CustomizableButton
            href={emergStateURL || '#'}
            onClick={handleClickEmerg}
            disabled={!emergStateURL}
            target='_blank'
            rel='noopener'
            elementType='a'
            supplementalStyling='h-12 min-h-0'
          >
            <span>
              Emergency
              <ExternalLinkIcon />
            </span>
          </CustomizableButton>
        </div>
      </div>
    </div>
  );
}

BallotTracker.propTypes = miniToolProps;
